
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 243 243"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3639.58,1855l-20.94,40.91h-11.75l20.38-38.74h-22.9v-9.78h35.21Z","transform":"translate(-3546.4 -1750.23)","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M3660.37,1896.74c-8.49,0-14.41-3.94-17.19-11l8.83-4.41a8.22,8.22,0,0,0,8.09,6,7.43,7.43,0,0,0,7.82-7.82c0-4.69-3.27-7.68-8.16-7.68a11.85,11.85,0,0,0-9,4.35l-5.71-2.72,1.7-26.16h29.57v9.78h-21.14l-.88,8.77c1.9-1.5,5.23-2.24,8.36-2.24,9,0,16.24,6,16.24,15.76C3678.86,1888.32,3672.74,1896.74,3660.37,1896.74Z","transform":"translate(-3546.4 -1750.23)","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M3694.35,1870.44a11.86,11.86,0,1,1,11.76-11.82A11.7,11.7,0,0,1,3694.35,1870.44Zm2.38,25.42h-7.81l30.31-48.52H3727Zm-2.38-42.34a5.1,5.1,0,1,0,5,5.1A4.94,4.94,0,0,0,3694.35,1853.52Zm27.33,43a11.86,11.86,0,1,1,11.75-11.89A11.7,11.7,0,0,1,3721.68,1896.47Zm0-16.92a4.89,4.89,0,0,0-5,5,5,5,0,1,0,9.93,0A4.88,4.88,0,0,0,3721.68,1879.55Z","transform":"translate(-3546.4 -1750.23)","fill":"#3b7cf7"}}),_c('circle',{attrs:{"cx":"121.5","cy":"121.5","r":"108","fill":"none","stroke":"#e6e6e6","stroke-miterlimit":"10","stroke-width":"27"}}),_c('path',{staticClass:"pieChart",attrs:{"d":"M3667.9,1763.73a108,108,0,1,1-108,108","transform":"translate(-3546.4 -1750.23)","fill":"none","stroke":"#3b7cf7","stroke-miterlimit":"10","stroke-width":"27"}})])
          )
        }
      }
    